import {FormEvent, useState} from 'react'
import styles from "./EsqueciSenha.module.css";
import Filler from "../../assets/Filler.jpeg";
import Logo from "../../assets/LogoPrincipal.png";
import {useTranslation} from "react-i18next";
import api from "../../utils/axios/api";


export default function EsqueciSenha(): JSX.Element {
  const { t } = useTranslation();

  const [email, setEmail] = useState('')

  const handleForgotPassword = async (evt: FormEvent) => {
    evt.preventDefault()
    try {
      await api.post(`/user/forgotPassword/${email}`)
      alert('Confira seu e-mail')
    } catch (error) {
      alert('Erro ao recuperar a senha.')
    }
  }

  return (
    <div className={styles.body}>

      <form onSubmit={handleForgotPassword} className={styles.container}>
        <img src={Logo} className={styles.Logo} />


        <div className={styles.title}>
          <div className={styles.wrapperTop}>
            <a href="/login">{t('EsqueciSenha.voltar')}</a>
          </div>
          <p className={styles.esqueci}>{t('EsqueciSenha.senha')}</p>
          <p className={styles.inserir}>{t('EsqueciSenha.inserir')}</p>
        </div>

        <div className={styles.wrapperInput}>
          <label htmlFor="email">{t('EsqueciSenha.email')}</label>
          <input value={email} onChange={(evt) => setEmail(evt.target.value)} className={styles.input} name="email" type="email" placeholder="E-mail" />
        </div>

        <button type="submit" className={styles.button}>{t('EsqueciSenha.finalizar')}</button>
      </form>

      <img src={Filler} className={styles.filler} />
    </div>
  );
}